









































































import { Vue, Component, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import * as api from "@/lib/api";
import logger from "@/configs/logger";
import { User } from "@/types";
import { Howl } from "howler";

@Component
export default class BugReport extends Vue {
  @State("user") user!: User;

  tone = new Howl({
    src: [require("@/assets/sounds/ToneNotification0.mp3")],
    loop: false,
    autoplay: false
  });

  dialog: boolean = false;
  report: string = "";
  loading: boolean = false;
  sent: boolean = false;
  hasError: boolean = false;

  @Watch("dialog")
  onUpdate(val: boolean, prev: boolean) {
    if (val) {
      this.sent = false;
      this.hasError = false;
      this.report = "";
    }
  }

  onSoundTest() {
    logger("info", "sound triggered");
    this.$toasted.success("Sound Test").goAway(2000);
    this.tone.play();
  }

  get isAllowed() {
    return (
      this.user.roles.includes("admin") ||
      this.user.roles.includes("verification")
    );
  }

  async submit() {
    try {
      this.hasError = false;
      this.loading = true;
      await fetch(
        "https://hooks.slack.com/services/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",
        {
          method: "POST",
          mode: "no-cors",
          body: JSON.stringify({ text: `${this.report} - ${this.user.email}` })
        }
      );

      this.sent = true;
      logger("log", "bug reported - ", this.report);
    } catch (err) {
      this.hasError = true;
      logger("error", "bug report error", err);
    } finally {
      this.loading = false;
    }
  }
}
